import ezjobHero from '../../../media/software/ezjob/homepage_ez.png';
import ezjob1 from '../../../media/software/ezjob/B6B25D8B-F911-43A2-8ED6-6CA5CFA61267.jpeg';
import ezjob3 from '../../../media/software/ezjob/F6A19EA4-5DBB-4353-9FC2-F11F1DDF2A8B_1_105_c.jpeg';

const ezJobData = {
  name: "EzJob",
  category: "Full-Stack Web Application",
  tagline: "Local gig marketplace connecting service providers with clients",
  duration: "Spring 2025",
  heroImage: ezjobHero,

  description: "[[EzJob::https://github.com/Madmaxme/EzJob]] is a dual-interface marketplace I developed during a semester abroad in Barcelona with three classmates from Germany. The platform connects local gig workers with clients through separate interfaces for providers and customers. I implemented Stripe for checkout and payment transfers, Firebase for authentication and real-time data, and deployed the React frontend on Vercel.",

  techStack: [
    "React",
    "Vercel",
    "Firebase",
    "Stripe API",
    "JavaScript",
    "Payment Processing",
    "Real-time Database",
    "User Authentication",
    "RESTful APIs",
    "Responsive Design",
    "Cloud Functions",
    "Firestore",
    "Collaborative Development"
  ],

  gallery: [
    { type: 'image', src: ezjobHero, alt: 'EzJob homepage' },
    { type: 'image', src: ezjob1, alt: 'Mockup drawing' },
    { type: 'image', src: ezjob3, alt: 'AI generated images' }
  ],
  links: {
    github: "https://github.com/Madmaxme/EzJob",
  },
};

export default ezJobData;
